'use es6';

import { createTracker } from 'usage-tracker-public';
import getCommonTrackerProperties from './commonTrackerProperties';
export default createTracker(getCommonTrackerProperties(true));